import TableReport from "../TableReport/TableReport";
import React, {useEffect, useState} from "react";
import {DimensionamentoService} from "../../services/DimensionamentoServices";
import {
  Container,
  Paper,
  Typography,
  Grid,
  Card,
  CardContent,
  Skeleton,
  LinearProgress,
  Alert, AccordionSummary, AccordionDetails, Accordion
} from '@mui/material';
import { 
  Analytics, 
  Assessment, 
  HealthAndSafety,
  TrendingUp,
  Group,
  LocalHospital
} from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const EstimativaReport = () => {
  const [originData, setOriginData] = useState({
    data: {
      dataObj: []
    },
    backupData: {
      dataObj: []
    }
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const titles = {
    "1.1": "Saúde materna",
    "1.2": "Saúde Infância e Adolescência", 
    "2.1": "Diabéticos",
    "2.2": "Hipertensos e Doenças Cardíacas",
    "2.3": "Doenças Renais",
    "2.4": "Doença Pulmonar",
    "3": "Portadores de Doenças Transmissíveis",
    "4": "Atenção à Saúde Bucal",
    "5": "Atenção à Saúde da Mulher",
    "6": "Atenção à Saúde do Adulto - Câncer",
    "7.1": "Tabagismo",
    "7.2": "Obesidade",
    "8": "Atenção à Saúde Mental",
    "9": "Atenção à Saúde dos Portadores de Necessidades Especiais - PNE",
  };

  const groupTitles = {
    "1": "ATENÇÃO À SAÚDE MATERNO INFANTIL",
    "2": "ATENÇÃO À SAÚDE - ADULTO E IDOSO (Doenças Crônicas não Transmissíveis - DCNT)",
    "3": "ATENÇÃO À SAÚDE - ADULTO E IDOSO ( Doenças Transmissíveis)",
    "4": "ATENÇÃO À SAÚDE BUCAL",
    "5": "ATENÇÃO À SAÚDE DA MULHER",
    "6": "ATENÇÃO À SAÚDE DO ADULTO (Câncer)",
    "7": "ATENÇÃO À SAÚDE DO ADULTO - FATORES DE RISCO À SAÚDE",
    "8": "ATENÇÃO À SAÚDE MENTAL",
    "9": "ATENÇÃO À SAÚDE DOS PORTADORES DE DEFICIÊNCIAS"
  };

  const insertTitlesInReport = () => {
    const sortTitles = Object.entries(titles).sort(([a], [b]) => {
      return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
    });

    const grouped = {};

    sortTitles.forEach(([prefix, title]) => {
      const group = prefix.split(".")[0];
      if (!grouped[group]) {
        grouped[group] = [];
      }
      grouped[group].push({ prefix, title });
    });

    return Object.entries(grouped).map(([group, subItems]) => {
      const groupTitle = groupTitles[group] || `Categoria ${group}`;

      return (
        <Accordion key={group} defaultExpanded sx={{ padding: {sm: "8px 12px", xs: '2px 5px'}, backgroundColor: "#f9fafb" }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography  className="text-emerald-800 font-semibold">{group}. {groupTitle}</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{padding: {sm: "8px 16px", xs: "2px 5px"}}}>
            {subItems.map(({ prefix, title }) => {
              const groupData = originData.data.dataObj.filter(item =>
                item.code === prefix || item.code.startsWith(prefix + ".")
              );
              if (groupData.length === 0) return null;

              const dataObj = {
                groupId: prefix,
                title,
                content: groupData
              };

              return (
                <TableReport
                  key={dataObj.groupId}
                  title={`Estimativas ${dataObj.groupId}: ${title}`}
                  data={dataObj}
                  city={selected}
                  tableType={"EstimativaReport"}
                  showCityLevel={true}
                  showMacroLevel={"Nan"}
                  showMicroLevel={"Nan"}
                  filterMissing={null}
                />
              );
            })}
          </AccordionDetails>
        </Accordion>
      );
    });
  };

  const selected = {
      selectedCity: "Nan",
      selectedMicro: "Nan",
      selectedMacro: "Nan",
      selectedObjCity: null
    }
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        const dados = await DimensionamentoService.getEstimates();
        setOriginData(prevState => ({
          ...prevState,
          backupData: dados
        }));
      } catch (err) {
        setError('Erro ao carregar dados de estimativas');
        console.error('Erro ao buscar estimativas:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchData()
  }, []);

  useEffect(() => {
    const fetchEstimates = async () => {
      try {
        setError(null);
        const res = await DimensionamentoService.getEstimates();
        if(!res) return
        
        let dataObj = []
        res.forEach((item) => {
            dataObj.push({
              ...item,
              reportGroup: parseInt(item.code)
            })
        })

        setOriginData(prevState => ({
          ...prevState,
          data: {
            dataObj: dataObj
          },
          backupData: {
            dataObj: dataObj
          }
        }));
      } catch (err) {
        setError('Erro ao processar dados de estimativas');
        console.error('Erro ao processar estimativas:', err);
      }
    };
    
    fetchEstimates();
  }, [selected.selectedObjCity, selected.selectedCity, selected.selectedMicro, selected.selectedMacro]);

  return (
    <Container maxWidth="xl" className="py-8">
      <Paper elevation={0} className="mb-8 p-6 bg-gradient-to-r from-emerald-50 to-teal-50 border border-emerald-200 rounded-xl">
        <div className="flex items-center space-x-4 mb-4">
          <div className="p-3 bg-emerald-100 rounded-xl">
            <HealthAndSafety className="h-8 w-8 text-emerald-700" />
          </div>
          <Typography sx={{ typography: {sm: 'h4', xs: 'body1'}}} className="font-bold text-gray-800">
            Estimativas <span className="text-emerald-700">Epidemiológicas</span>
          </Typography>
        </div>
        <div className='mb-4 text-justify'>
          <Typography sx={{typography: {sm: 'body1', xs:'body2'}}} className="text-gray-600 mt-1">
            As estimativas epidemiológicas referem-se à análise completa dos dados demográficos e do perfil de utilização de 100% dos beneficiários da Operadora. Essa análise é segmentada por sexo e faixas etárias específicas para cada linha de cuidado, fundamentada em referências nacionais.
          </Typography>
        </div>
        
        {originData.data.dataObj.length > 0 && !loading && (
          <Grid container spacing={3} className="mt-4">
            <Grid item xs={12} sm={6} xl={3}>
              <div className="bg-white rounded-lg p-4 border border-emerald-100">
                <div className="flex items-center justify-between">
                  <div>
                    <Typography variant="h6" className="font-semibold text-emerald-700">
                      {Object.keys(titles).length}
                    </Typography>
                    <Typography variant="body2" className="text-gray-600">Categorias</Typography>
                  </div>
                  <Analytics className="h-8 w-8 text-emerald-500" />
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} xl={3}>
              <div className="bg-white rounded-lg p-4 border border-emerald-100">
                <div className="flex items-center justify-between">
                  <div>
                    <Typography variant="h6" className="font-semibold text-emerald-700">
                      {originData.data.dataObj.length}
                    </Typography>
                    <Typography variant="body2" className="text-gray-600">Total Estimativas</Typography>
                  </div>
                  <Assessment className="h-8 w-8 text-emerald-500" />
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} xl={3}>
              <div className="bg-white rounded-lg p-4 border border-emerald-100">
                <div className="flex items-center justify-between">
                  <div>
                    <Typography variant="h6" className="font-semibold text-emerald-700">
                      {originData.data.dataObj.filter(item => item.value > 0).length}
                    </Typography>
                    <Typography variant="body2" className="text-gray-600">Com Prevalência</Typography>
                  </div>
                  <TrendingUp className="h-8 w-8 text-emerald-500" />
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} xl={3}>
              <div className="bg-white rounded-lg p-4 border border-emerald-100">
                <div className="flex items-center justify-between">
                  <div>
                    <Typography variant="h6" className="font-semibold text-emerald-700">
                      {new Set(originData.data.dataObj.map(item => item.code.split('.')[0])).size}
                    </Typography>
                    <Typography variant="body2" className="text-gray-600">Grupos Principais</Typography>
                  </div>
                  <Group className="h-8 w-8 text-emerald-500" />
                </div>
              </div>
            </Grid>
          </Grid>
        )}
      </Paper>

      {error && (
        <Alert severity="error" className="mb-6">
          <Typography variant="body1">{error}</Typography>
        </Alert>
      )}

      {loading ? (
        <Card elevation={2} className="border border-gray-200">
          <CardContent className="p-12">
            <div className="space-y-8">
              <div className="text-center">
                <Skeleton variant="circular" width={80} height={80} className="mx-auto mb-4" />
                <Skeleton variant="text" height={40} width="60%" className="mx-auto mb-2" />
                <Skeleton variant="text" height={24} width="40%" className="mx-auto" />
              </div>
              
              <Grid container spacing={3}>
                {[1, 2, 3, 4].map((item) => (
                  <Grid item xs={12} sm={6} xl={3} key={item}>
                    <div className="bg-gray-50 rounded-lg p-4">
                      <div className="flex items-center justify-between">
                        <div className="space-y-2 flex-1">
                          <Skeleton variant="text" height={32} width="80%" />
                          <Skeleton variant="text" height={20} width="60%" />
                        </div>
                        <Skeleton variant="circular" width={40} height={40} />
                      </div>
                    </div>
                  </Grid>
                ))}
              </Grid>

              <div className="space-y-4">
                {[1, 2, 3].map((item) => (
                  <div key={item} className="bg-gray-50 rounded-lg p-6">
                    <div className="flex items-center justify-between mb-4">
                      <Skeleton variant="text" height={32} width="40%" />
                      <Skeleton variant="circular" width={32} height={32} />
                    </div>
                    <div className="space-y-2">
                      <Skeleton variant="rectangular" height={60} />
                      <Skeleton variant="rectangular" height={40} />
                      <Skeleton variant="rectangular" height={40} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </CardContent>
        </Card>
      ) : (
        <div className="space-y-6">
          <Card elevation={2} className="border border-gray-200">
            <CardContent className="p-6">
              <div className="flex items-center space-x-3 mb-6">
                <div className="p-2 bg-emerald-100 rounded-lg">
                  <LocalHospital className="h-5 w-5 text-emerald-700" />
                </div>
                <div>
                  <Typography sx={{ typography: {sm: 'h6', xs: 'body1'}}} className="font-semibold text-gray-800">
                    Estimativa Epidemiológica populacional por Linha de cuidado/Ciclo de vida
                  </Typography>
                  <Typography variant="body2" className="text-gray-600">
                    Estimativas organizadas por área de atenção à saúde
                  </Typography>
                </div>
              </div>

              {loading && (
                <div className="mb-6">
                  <LinearProgress 
                    className="h-2 rounded-full"
                    sx={{
                      backgroundColor: '#e5e7eb',
                      '& .MuiLinearProgress-bar': {
                        backgroundColor: '#059669',
                        borderRadius: '9999px',
                      },
                    }}
                  />
                  <Typography variant="body2" className="text-gray-600 mt-2 text-center">
                    Carregando estimativas...
                  </Typography>
                </div>
              )}

              <div className="space-y-4">
                {originData.data.dataObj.length > 0 ? (
                  insertTitlesInReport()
                ) : !loading && (
                  <div className="text-center py-12">
                    <HealthAndSafety className="h-16 w-16 text-gray-400 mx-auto mb-4" />
                    <Typography variant="h6" className="text-gray-600 mb-2">
                      Nenhuma estimativa encontrada
                    </Typography>
                    <Typography variant="body2" className="text-gray-500">
                      Não há dados de estimativas epidemiológicas disponíveis no momento
                    </Typography>
                  </div>
                )}
              </div>
            </CardContent>
          </Card>
        </div>
      )}
    </Container>
  );};

export default EstimativaReport;